import { HttpClient } from "@angular/common/http";
import { Component, EventEmitter, Input, OnInit, Output, Renderer2, computed, signal } from "@angular/core";
import { AppService } from "@root/app.service";
import { PlatformType } from "@root/config";
import { TranslateService } from "@root/shared/service/translate.service";
import { pick } from "lodash";
import { NzMessageService } from "ng-zorro-antd/message";

@Component({
  selector: "room-type-detail-pricing",
  templateUrl: "./pricing.component.html",
  styleUrls: ["./pricing.component.scss"],
})
export class RTPricingComponent implements OnInit {
  private readonly SaveApi = "/api/calendar/edit_basic_price";
  readonly DailyPriceUnsupportedChannels = [
    PlatformType.Booking,
    PlatformType.Ctrip,
    PlatformType.Fliggy,
    PlatformType.Vrbo,
    PlatformType.Agoda,
    PlatformType.MeiTuanJiuDian,
  ];
  readonly WeekendPriceUnsupportedChannels = [
    // PLATFORM_TYPE.XIAOZHU,
    PlatformType.MuNiao,
    ...this.DailyPriceUnsupportedChannels,
  ];
  @Input() id;
  @Input() originHouseId;
  @Input() prices = [];
  @Output() onNavigate = new EventEmitter();
  batchDailyPrice;
  batchWeekendPrice;

  listOfHouse = [];
  listOfHouseSupportSetRules = [];
  total = 0;
  page = 1;
  pageSize = 20;
  currentHouse;
  showBookingSettings = false;
  //#region ShowAllListings
  showMoreListings = signal<boolean>(false);
  readonly showMoreListingsLimit = 4;
  showMoreListingsText = computed(() => {
    return this.showMoreListings()
      ? this.t.t("property-property_detail-pricing-ratio_html_spo_less")
      : this.t.t("property-property_detail-pricing-ratio_html_spo_more", {
          number: this.prices.length - this.showMoreListingsLimit,
        });
  });
  //#endregion
  get isInternational() {
    return this.app.app.international;
  }
  constructor(
    private http: HttpClient,
    private msg: NzMessageService,
    private app: AppService,
    private t: TranslateService,
  ) {}

  ngOnInit() {
    this.fetchBindedHouses();
  }

  onSave() {
    this.requestSave();
  }

  isSupportPrice(type: "daily_price" | "weekend_price", channel) {
    if (type === "daily_price") {
      return this.isSupportDailyPrice(channel);
    } else {
      return this.isSupportWeekendPrice(channel);
    }
  }

  isSupportDailyPrice(channel) {
    return this.DailyPriceUnsupportedChannels.indexOf(channel) === -1;
  }

  isSupportWeekendPrice(channel) {
    return this.WeekendPriceUnsupportedChannels.indexOf(channel) === -1;
  }

  isSupportSetRules(channel) {
    return channel === PlatformType.Vrbo || channel === PlatformType.Airbnb;
  }

  onBatchDailyPriceChange() {
    this.prices.forEach((price) => {
      price.daily_price = this.batchDailyPrice;
    });
  }

  onBatchWeekendPriceChange() {
    this.prices.forEach((price) => {
      price.weekend_price = this.batchWeekendPrice;
    });
  }

  onPageChange() {}

  onClickHouse(house) {
    if (!this.isSupportSetRules(house.thirdparty_type)) {
      return;
    }
    this.showBookingSettings = true;
    this.currentHouse = house;

    this.onNavigate.emit();
  }

  private fetchBindedHouses() {
    const params = {
      house_type_id: this.id,
    };
    this.http.get("/api/house_type/platform_list", { params }).subscribe((rst: any) => {
      this.listOfHouse = rst?.data?.list;
      this.listOfHouseSupportSetRules = this.listOfHouse?.filter((house) =>
        this.isSupportSetRules(house.thirdparty_type),
      );
      console.log("list of support set rules: ", this.listOfHouseSupportSetRules);
      console.log("originHouseId: ", this.originHouseId);
      if (this.originHouseId) {
        const house = this.listOfHouseSupportSetRules.find((item) => item.origin_house_id === this.originHouseId);
        this.onClickHouse(house);
      }
    });
  }

  private requestSave() {
    const prices = this.prices.map((item) => ({
      ...pick(item, ["daily_price", "weekend_price", "thirdparty_type", "origin_house_id"]),
    }));
    const params = {
      type: 1,
      basic_prices_list: JSON.stringify(prices),
    };
    this.http.post(this.SaveApi, params).subscribe((rst: any) => {
      if (rst?.error_code === 0) {
        this.msg.success(this.t.t("success.save"));
      }
    });
  }
}
